export default "__VITE_ASSET__DTvtunEd__"